export default /*html*/ `
<button type="button" class="btn cancel" data-dismiss="modal">
    Cancelar
</button>
<button type="button" class="btn save save-list-modal"  data-dismiss="modal">
    Salvar
</button>`
